import "../../assets/css/product.scss";
import closeSvg from "../../assets/images/icons/close.svg";

function RequestCancelModal({
  isCancelModalOpen,
  formData,
  errors,
  isSubmitting,
  closeCancelModal,
  updateFormData,
  submitCancelRequest,
  onSuccess,
}) {
  const bankOptions = [
    "KB국민은행",
    "신한은행",
    "우리은행",
    "하나은행",
    "NH농협은행",
    "IBK기업은행",
    "SC제일은행",
    "씨티은행",
    "경남은행",
    "광주은행",
    "대구은행",
    "부산은행",
    "전북은행",
    "제주은행",
    "수협은행",
    "새마을금고",
    "신협",
    "우체국",
    "카카오뱅크",
    "토스뱅크",
    "케이뱅크",
  ];

  const handleSubmit = async () => {
    const success = await submitCancelRequest();
    if (success && onSuccess) {
      onSuccess();
    }
  };

  if (!isCancelModalOpen) return null;

  return (
    <div className="product-auth-modal modal-wrap">
      <div
        className="overlay"
        onClick={() => {
          closeCancelModal();
        }}
      >
        <div
          className="modal cancel-request-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div>
            <button
              className="closeBtn"
              onClick={() => {
                closeCancelModal();
              }}
            >
              <img src={closeSvg} alt="" />
            </button>
          </div>

          <div className="content">
            <h2 className="modal-title">구독 취소 신청</h2>
            <p className="modal-subtitle">
              환불받으실 계좌정보와 취소사유를 입력해주세요.
            </p>

            <div className="form-group">
              <label htmlFor="bankName">은행명 *</label>
              <select
                id="bankName"
                value={formData.bankName}
                onChange={(e) => updateFormData("bankName", e.target.value)}
                className={errors.bankName ? "error" : ""}
              >
                <option value="">은행을 선택해주세요</option>
                {bankOptions.map((bank) => (
                  <option key={bank} value={bank}>
                    {bank}
                  </option>
                ))}
              </select>
              {errors.bankName && (
                <span className="error-message">{errors.bankName}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="accountNumber">계좌번호 *</label>
              <input
                type="text"
                id="accountNumber"
                placeholder="계좌번호를 입력해주세요 (숫자만)"
                value={formData.accountNumber}
                onChange={(e) =>
                  updateFormData("accountNumber", e.target.value)
                }
                className={errors.accountNumber ? "error" : ""}
                maxLength={20}
              />
              {errors.accountNumber && (
                <span className="error-message">{errors.accountNumber}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="accountHolder">예금주명 *</label>
              <input
                type="text"
                id="accountHolder"
                placeholder="예금주명을 입력해주세요"
                value={formData.accountHolder}
                onChange={(e) =>
                  updateFormData("accountHolder", e.target.value)
                }
                className={errors.accountHolder ? "error" : ""}
                maxLength={20}
              />
              {errors.accountHolder && (
                <span className="error-message">{errors.accountHolder}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="cancelReason">취소사유</label>
              <textarea
                id="cancelReason"
                placeholder="취소사유를 10자 이상 상세히 입력해주세요"
                value={formData.cancelReason}
                onChange={(e) => updateFormData("cancelReason", e.target.value)}
                className={errors.cancelReason ? "error" : ""}
                rows={4}
                maxLength={500}
              />
              <div className="char-count">
                {formData.cancelReason.length}/500
              </div>
              {errors.cancelReason && (
                <span className="error-message">{errors.cancelReason}</span>
              )}
            </div>

            <div className="button-group">
              <button
                type="button"
                className="cancel-btn"
                onClick={() => {
                  closeCancelModal();
                }}
                disabled={isSubmitting}
              >
                취소
              </button>
              <button
                type="button"
                className="submit-btn"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "처리 중..." : "취소 신청"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestCancelModal;
